import * as React from 'react'
import { useRouter } from 'next/router'

import { createPage } from '@app/nextjs'

import { useAuth } from '@saas-ui/auth'
import { AppLayout } from '@app/features/core/layouts/app-layout'
import { DemoPage } from '@app/features/tenants/pages/demo'

const Demo = () => {
  return <DemoPage />
}

export default createPage({
  title: 'Demo',
  layout: 'fullscreen',
  isPublic: true,
  renderComponent: () => <Demo />,
})
